const _ = (data: any) => {
  return [
    {
      name: data.productNumber,
      id: data.productNumber,
      brand: data.manufacturer,
      position: data.position
    }
  ];
};

export default (data: any, event: string) => {
  const dataLayerObject = _(data.product);
  return {
    event,
    ecommerce: {
      click: {
        actionField: { list: data.list, listPage: data.listPage },
        products: [...dataLayerObject]
      }
    }
  };
};
